import { NextSeo } from "next-seo";

import type { NextSeoProps } from "next-seo";

export const SEO = (props: NextSeoProps) => <NextSeo {...props} />;
